import { render, staticRenderFns } from "./AddFeedbackChatCommentsDialog.vue?vue&type=template&id=fe714902&"
import script from "./AddFeedbackChatCommentsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddFeedbackChatCommentsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports